<template>
  <div class="app-auto-top-up-success">
    <slot name="txtBefore">Vielen Dank</slot>
    <dyn-slot :slot-data="slotData" v-if="selectedType === 'ACCOUNT_BALANCE'">
      <slot name="txtSuccessByLimit"></slot>
    </dyn-slot>
    <dyn-slot :slot-data="slotData" v-if="selectedType === 'DAY_OF_MONTH'">
      <slot name="txtSuccessByMonthly"></slot>
    </dyn-slot>
    <dyn-slot :slot-data="slotData" v-if="view === 'deactivate'">
      <slot name="txtSuccessByDeactivation"></slot>
    </dyn-slot>
    <b-form>
      <Stepper
        :show-next="false"
        :show-prev="showPrev"
        @prev=goBack()
      >
        <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Stepper>
      <LogOut v-if="showLogout"></LogOut>
    </b-form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import Stepper from '@/components/generic/Stepper.vue'
import { mapGetters, mapMutations } from 'vuex'
import processSteps from '@/mixins/processSteps'
import price from '@/mixins/price'
import slotProxy from '@/mixins/slotProxy'
import LogOut from '@/components/process/generic/Authentication/LogOut/LogOut.vue'
export const stepName = 'success'

export default {
  name: 'AutoTopUpSuccess',
  components: { LogOut, Stepper },
  computed: {
    ...mapGetters('topUp', [
      'topUpData',
      'currentView'
    ]),
    formattedAmount: function () {
      return this.price(this.topUpData?.topUp?.amount)
    },
    formattedTrigger: function () {
      return this.price(this.topUpData?.topUp?.trigger)
    },
    selectedType: function () {
      return this.topUpData?.topUp?.type
    },
    slotData: function () {
      return {
        formattedAmount: this.formattedAmount,
        formattedTrigger: this.formattedTrigger
      }
    },
    view: function () {
      return this.currentView
    }
  },
  methods: {
    ...mapMutations('topUp', [
      'setCurrentView',
      'resetSuccess'
    ]),
    goBack () {
      this.setCurrentView('default')
      this.resetSuccess(false)
    }
  },
  props: {
    showPrev: {
      type: Boolean,
      default: true
    },
    showLogout: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    processSteps(stepName),
    slotProxy(['Stepper']),
    price
  ]
}
</script>
